import axios from "axios";
import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { accessTokenState } from "../recoil/atom/accessTokenState";

export default function useConfigAccessToken() {
  const MINUTE_MS = 10000000;

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const setAccessToken = useSetRecoilState(accessTokenState);

  useEffect(() => {
    let test = async function () {
      const params = new URLSearchParams({
        grant_type: 'client_credentials',
        //scope: 'openid profile email',
        client_id: 'memopet-mobile',
        client_secret: 'JJd4k957wScnL0Kbi1h3d4ml79Effi9C'
      });
    
      const options = {
        method: 'post',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: params.toString(),
        url: 'https://auth.myfamily.network/realms/myfamily-customers/protocol/openid-connect/token'
      };
      axios(options)
      .then(res => {
        // console.warn('authenticate', res)
        setAccessToken(res.data.access_token)
        setLoading(false)
      })
      .catch((err) => {
        console.warn('authenticate error', err)
        setError(true)
      })   
    }
      
    test()
    
  }, []);

  return { error, loading};
}
